import React from "react";

export default function Coder(props) {
  return (
    <div className="coder">
      <p>
        Coded by Maria C. <br />
        <a href="https://github.com/mcosme000/React-weather-app">
          open sourced on Github
        </a>
      </p>
    </div>
  );
}
